import { Col, Row, Tag } from 'antd'
import styled from '@emotion/styled'

export const RowAntd = styled(Row)``

export const ColAntd = styled(Col)``

export const Container = styled('div')`
  margin-top: 16px;
`

export const HeaderContainer = styled('div')``

export const TitleContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TitleBox = styled('div')`
  display: flex;
  align-items: center;
`

export const Title = styled('div')`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #000000;
  margin-right: 8px;
`

export const Subtitle = styled('div')`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #adadad;
`

export const SignedBox = styled(Tag)`
  font-size: 12px;
  font-weight: 400;
  color: #276ef1;
  background-color: #e2f2ff;
`

export const TextCountFile = styled('div')`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #666666;
`

export const TitleAction = styled('div')``

export const IconSvg = styled('img')`
  height: 20px;
  width: 20px;
  cursor: pointer;
  margin-left: 10px;
`

export const ImageContainer = styled('div')`
  margin: 16px 0px;
`

export const UploadInputImage = styled('input')`
  display: none;
`
